<template>
  <div>
    <div class="fav-top">
      <div
        v-for="(item, index) in favoriteMenus"
        :key="index"
        :style="{ borderRight: index === favoriteMenus.length - 1 ? 'none' : '1px solid #e7e9ec' }"
        class="fav-menu_list"
        @click="itemClick(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="color-line"></div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import store from "@/store"

export default {
  name: "FavTopMenuIndex",
  computed: {
    ...mapState("user", ["favoriteMenus"])
  },
  methods: {
    // 点击菜单
    itemClick(item) {
      item.bfList = item.list
      // 判断，当前Url下面，是否有相对应的页面，如果没有，则提示不允许进入
      let havePage = false
      if (item.bfList && item.bfList.length > 0) {
        item.bfList.forEach(bfItem => {
          if (bfItem.type === 2 && item.url === bfItem.url) {
            // 并且当前名字，改为页面的名字
            if (!item.meta) {
              item.meta = {
                title: bfItem.name
              }
            } else {
              item.meta.title = bfItem.name
            }
            havePage = true
          }
        })
        if (!havePage) {
          this.$message.warning("请先设置当前菜单下的页面！")
          return
        }
      } else {
        if (!havePage) {
          this.$message.warning("请先设置当前菜单下的页面！")
          return
        }
      }
      item.fullPath = this.resolvePath(item.url)
      if (!item.meta) {
        item.meta = {
          title: item.name
        }
      }
      // 补全 丢失信息
      if (!item.sysBelong) {
        item.sysBelong = item.fullPath.split("#")[0]
      }
      if (!item.pathName) {
        const hasData = store.state.user.oneDimensionalMenu.filter(localItem => localItem.url === item.url)[0]
        item.pathName = hasData?.pathName
      }
      this.$router.push({ path: item.fullPath })
      this.$store.dispatch("tagsView/addView", item)
      // 重制nowSys,让二层菜单隐藏
      this.$store.commit("user/SET_NOWSYS", "")
      // 判断是否是收缩时，点击弹起的，如果是，则再次收缩
      if (this.sidebarFakeClick) {
        this.$store.dispatch("app/toggleSideBar")
      }
    },
    resolvePath(routePath) {
      // 帆软报表暂时处理，后期需要统一在数据中心，进行页面前置
      if (routePath === "https://fr.osa.com/webroot/decision/view/report?viewlet=/流程与IT/帆软广告回本报表.cpt") {
        return "/count#/count/fanruan"
      }
      if (routePath === "https://fr.osa.com/webroot/decision/view/form?viewlet=WCT/数据中心/AB客_裂变销售报表.frm") {
        return "/count#/count/fanruanAB"
      }
      // //权限中心比较特殊，没有作为一个中心上传git，而是和主数据合在一起，所以需要单独判断下
      const isAuthorityCenter = routePath.split("/")?.[1] === "authorityCenter"
      if (isAuthorityCenter) {
        return "/masterData" + "#" + routePath
      } else {
        return "/" + routePath.split("/")[1] + "#" + routePath
      }
    }
  }
}
</script>
<style scoped lang="scss">
.fav-top {
  width: calc(100% - 5px);
  background: #ffffff;
  display: flex;
  overflow-x: scroll;
  margin-left: 5px;
  .fav-menu_list {
    flex-shrink: 0;
    margin: 5px 0;
    padding: 5px 18px;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    cursor: pointer;
  }
  .fav-menu_list:hover {
    color: #3296fa;
  }
}
// 滚动条
.fav-top::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}
.color-line {
  width: 100%;
  height: 1px;
  background: #f0f2f5;
}
</style>
